export const userRoleTitle = {
    ADMIN: "Admin",
    CHAMPION: "Champion",
    USER: "User",
    INACTIVE: "Inactive",
} as const;

export type UserRole = (typeof userRoleTitle)[keyof typeof userRoleTitle];

export const userRoleToAccountRole = {
    [userRoleTitle.ADMIN]: "AccountAdmin",
    [userRoleTitle.CHAMPION]: "AccountChampion",
    [userRoleTitle.USER]: "AccountUser",
    [userRoleTitle.INACTIVE]: "AccountInactiveUser",
} as const satisfies Record<UserRole, string>;
